import React, { useState, useEffect } from "react";
import { ArrowRight, ShieldCheck, CreditCard, Zap } from "lucide-react";
import Reveal from "./Reveal";

const PHONE_SLIDES = [
  "/phone-slide-1.jpg",
  "/phone-slide-2.jpg",
  "/phone-slide-3.jpg",
  "/phone-slide-4.jpg",
];

const PhoneMockup = () => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(
      () => setIndex((i) => (i + 1) % PHONE_SLIDES.length),
      3500
    );
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="relative animate-[phonefloat_6s_ease-in-out_infinite]">
      <div className="w-[280px] sm:w-[300px] h-[560px] sm:h-[590px] bg-white rounded-[2.8rem] border-[10px] border-black shadow-[0_30px_60px_-15px_rgba(0,0,0,0.25)] overflow-hidden relative">
        {PHONE_SLIDES.map((src, i) => (
          <img
            key={src}
            src={src}
            alt={`K PLAZA mobil uygulama ekranı ${i + 1}`}
            className={`absolute inset-0 w-full h-full object-cover object-top transition-opacity duration-700 ease-in-out ${
              i === index ? "opacity-100" : "opacity-0"
            }`}
          />
        ))}
        {/* Slayt göstergesi */}
        <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex items-center gap-1.5 bg-white/80 backdrop-blur rounded-full px-2.5 py-1.5 shadow-sm">
          {PHONE_SLIDES.map((_, i) => (
            <button
              key={i}
              onClick={() => setIndex(i)}
              aria-label={`Slayt ${i + 1}`}
              className={`rounded-full transition-all duration-300 ${
                i === index ? "w-4 h-1.5 bg-black" : "w-1.5 h-1.5 bg-neutral-300"
              }`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

const AUDIENCES = [
  { title: "Bireysel kullanıcılar", desc: "QR kodunu okut, anlaşmalı işletmelerde standart indirimini kazan." },
  { title: "İşletmeler", desc: "Profilini oluştur, yeni müşterilerle buluş, kampanyalarını duyur." },
];

const Hero = () => {
  const scrollToPackages = () => {
    document.getElementById("paketler")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="top" data-testid="hero-section" className="relative bg-black/55">
      <div className="max-w-6xl mx-auto px-6 py-16 lg:py-24 grid lg:grid-cols-2 gap-14 items-center">
        <Reveal>
          <div>
            <div className="flex items-center gap-2">
              <span className="w-2 h-2 bg-amber-400 inline-block" />
              <span className="text-[11px] tracking-[0.25em] font-semibold text-amber-300">
                K-PLAZA · BİREYSEL &amp; İŞLETME
              </span>
            </div>

            <h1 data-testid="hero-title" className="mt-6 text-4xl sm:text-5xl font-bold leading-[1.1] text-white">
              Bireyleri ve
              <br />
              işletmeleri tek
              <br />
              <span className="italic font-light text-amber-300">
                uygulamada buluşturuyoruz
              </span>
            </h1>

            <p data-testid="hero-description" className="mt-6 text-sm leading-6 text-neutral-200 max-w-md">
              Bireysel kullanıcılar K-Plaza uygulamasındaki kişisel QR kodlarıyla
              anlaşmalı işletmelerde standart indirim kazanır. İşletmeler ise
              yeni müşterilere ulaşır; kampanyalarını ve projelerini binlerce
              kullanıcıya duyurur.
            </p>

            <div className="mt-6 grid sm:grid-cols-2 gap-3 max-w-md">
              {AUDIENCES.map((a) => (
                <div key={a.title} className="bg-white/10 backdrop-blur-md border border-white/15 rounded-xl p-4">
                  <div className="text-xs font-bold text-white">{a.title}</div>
                  <p className="mt-1 text-[11px] leading-4 text-neutral-300">{a.desc}</p>
                </div>
              ))}
            </div>

            <div className="mt-8 flex flex-wrap items-center gap-3">
              <button
                data-testid="hero-packages-btn"
                onClick={scrollToPackages}
                className="inline-flex items-center gap-2 bg-white text-black text-sm font-medium px-5 py-3 rounded-lg hover:bg-amber-100 transition-colors"
              >
                Paketleri İncele
                <ArrowRight className="w-4 h-4" />
              </button>
            </div>

            <div className="mt-7 flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-neutral-300">
              <span className="inline-flex items-center gap-1.5">
                <ShieldCheck className="w-4 h-4 text-amber-400" />
                Güvenli Ödeme
              </span>
              <span className="inline-flex items-center gap-1.5">
                <CreditCard className="w-4 h-4 text-amber-400" />
                iyzico
              </span>
              <span className="inline-flex items-center gap-1.5">
                <Zap className="w-4 h-4 text-amber-400" />
                Anında Erişim
              </span>
            </div>
          </div>
        </Reveal>

        <Reveal delay={150}>
          <div className="flex justify-center lg:justify-end">
            <PhoneMockup />
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Hero;
